import { Box, Divider, Link, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  root: {
    minHeight: "100vh",
    background: "var(--background-color)",
    color: "var(--text-color)",
    padding: "40px 24px",
    maxWidth: 860,
    margin: "0 auto",
  },
  section: {
    marginTop: 28,
  },
  contact: {
    marginTop: 8,
    lineHeight: 1.8,
  },
  note: {
    background: "var(--list-item-sel-color, #f0f4ff)",
    borderLeft: "4px solid #3f51b5",
    padding: "10px 16px",
    borderRadius: 4,
    margin: "12px 0",
  },
}));

export default function SupportPage() {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="h4" gutterBottom>
        QLearn Support
      </Typography>
      <Typography variant="body2" style={{ color: "#808080" }}>
        Support for QLearn ABSITE subscriptions, account access, and study tools.
      </Typography>
      <Divider style={{ margin: "16px 0" }} />

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Contact Support</Typography>
        <Typography variant="body2">
          For help with your QLearn ABSITE account, subscription access, restore purchases,
          login issues, or study workflow questions, contact Medlearnity support.
        </Typography>
        <Typography variant="body2" className={classes.contact}>
          Email: <Link href="mailto:support@medlearnity.com">support@medlearnity.com</Link><br />
          Phone: <Link href="tel:+16315402499">+1 (631) 540-2499</Link>
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Subscriptions And Purchases</Typography>
        <Typography variant="body2">
          If you subscribe through the iOS app, your purchase is managed by your Apple ID.
          You can use Restore Purchases in the app to reconnect an active App Store subscription
          to your QLearn account. If you subscribed on desktop, contact support for billing or
          access questions.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Account Access</Typography>
        <Typography variant="body2">
          If you cannot sign in, reset your password from the QLearn login screen or email
          support with the email address tied to your QLearn account. Do not send passwords,
          payment card details, or private medical information by email.
        </Typography>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Educational Use</Typography>
        <Box className={classes.note}>
          <Typography variant="body2">
            QLearn ABSITE is an educational test-prep product. It is not intended for clinical
            decision support, diagnosis, treatment, or patient care.
          </Typography>
        </Box>
      </Box>

      <Box className={classes.section}>
        <Typography variant="h6" gutterBottom>Policies</Typography>
        <Typography variant="body2" className={classes.contact}>
          <Link href="/privacy-policy">Privacy Policy</Link><br />
          <Link href="/terms">Terms of Service</Link>
        </Typography>
      </Box>

      <Box style={{ marginTop: 40, marginBottom: 16 }}>
        <Divider />
      </Box>
    </Box>
  );
}
